//var $ = require("jquery");
//Kasper1
/* $.when(
     
    $.getScript(),
    $.Deferred(function( deferred ){
        $( deferred.resolve );
    })
).done(function(){
     //place your code here, the scripts are all loaded
     
    //GET URL;
    //alert(tomato);
}); */
//pagetitel
//$.getScript( "/js/getUrlParameter.js" ),
/*########################################################
    All functions
#########################################################*/
$(document).ready(function() {
  /* super fed funktion...
            window.onbeforeunload = function () {
   return "You have not saved your document yet.  If you continue, your work will not be saved."
}
             
        */
  //Globals to use
  //Kan benyttes hvis man ønsker dette kun skal benyttes på en aktuel side.
  var pathname = window.location.pathname; //'/recipe/add_name.php'
  var url = window.location.href; // full location
  var parts = location.hostname.split('.');
  var subdomain = parts.shift();
  var upperleveldomain = parts.join('.');
  var saveurl = "/db_save";
  var deleteurl = "/db_delete";
  //var sndleveldomain = parts.slice(-2).join('.');
  var sPageURL = window.location.search.substring(1); // ?id=234
  /*#######################
            Master module
        #######################*/
  var FF = (function() {
    //$.cookie("visits",10); // print "10"
    //var testCo = createCookie('test',342,1);
    //console.debug(testCo);
    //A
    test();
    
    AlertSuccess();
    AddNewNameShoppingList();
    //AutoSize();
    //B
    BrowserLanguage();
    //C
    //D
    DynamicSelect();
    //E
    EnvelopesToRecipe();
    EditItemFromShoppingList();
    //F
    FileInput();
    Filters();
    FadeEffect();
    FormSubmitning();
    Flipicon();
    //G
    getUrlParameter();
    GoogleAnalytics();
    //H
    HideShowLevels();
    //I
    introlist();
    //J
    //Json_add_to_basket();
    //K
    //L
    LevelPriorStricture();
    LoginSpinder(); 
    //M
    MakeAsLink();
    //N
    NewUserItem_DropDown();
    NewIngredient();
    //O
    OnOffSwitch(); 
    overlaywrapper();
    Overlay();
    
    //P
    //Q
    //R
    Recipe_CompleteOneOfTheSteps();
    RecipeSearchOverview();
    //S
    Stars();
    ShowHideStates();
    SectionHeight();
    SaveJson();
    Slick();
    //T 
    //U 
    //V
    //W
    WindowWidth();
    //X
    //Y
    //Z 
  })();
  
  function test() {  
	if (Navigator.onLine) {
		console.log('online');
	} else {
		console.log('offline');
	}
	  
  }
  
  /*############## LEARN ANGULARJS START #####################*/
  //angular.module("app",[]);
  /*############## LEARN ANGULARJS END #####################*/
  
  function introlist() {
	  var MainList = $('.categories').find('.introlist');
	  var MainListRow = MainList.find('.cetertext');
	  var sPageURL = window.location.search.substring(1).split('&');
	  
	  if (sPageURL[0] != 'automate') {
	  	MainList.find('.childlist').hide();
	  }
	  $('.introlist .js-main').on("click",function() {
      var getid = $(this).parent().attr('id');
      var getmainlist = $('#' + getid);
      var getchildlist = getmainlist.find('.childlist');
	 // MainList.find('.childlist').hide();
      //getid = $(this).parent().attr('id');
      	 //$('#' + getid + ' .cetertext' ).on("click", function() {
	      	 getmainlist.find('.fa').toggleClass('fa-rotate-90');
	      	 getchildlist.slideToggle('fast');
      	 //});
	  }); 
  }
  
  function Slick() { 
	  $('.slider').slick({
		arrows: false,
	  	centerMode: true,
	  	centerPadding: '20px',
	  	slidesToShow: 1 
	  });
  }
  
  function SaveJson() {
	  //recipes -> your
	  $("#load").click(function(){
	    Json_loadmore_recipes_your();
	  });
	  
	  $("#top .add_as_favorites").click(function(){
	    Json_add_as_favorit();
	  });
	  
	  $("#popup").on("click", ".add_season", function() {
	  //$(".add_season").click(function() {
		  Json_add_season_to_recipe();
	  });
	  
	  $("#shoppinglist .addtobasket").click(function(){
	    var itemid = this.id;
	    var thisitem = $(this);
	    var getel = thisitem.siblings().length;
	    //console.log(getel); 
	    Json_add_to_basket(thisitem, itemid, getel);
	  });
	  
  }
  
  	function Json_add_season_to_recipe() {
		var sPageURL = window.location.search.substring(10).split('&');
		var seasonid = $('#seasonname>option:selected').val();
		//console.log('seasonid:' + seasonid);
		//console.log('recipeid:' + sPageURL[0]);
		$.ajax({
			type: 'post',
			url: saveurl + '/recipe/add_season.php?recipeid=' + sPageURL[0] + '&seasonid=' + seasonid,
			data: {
				//getresult:val
			},
			success: function (response) {  
		    	overlaywrapperhide();
		    	//console.log('This season is now added to recipe...');
		    	/*var getul = thisitem.closest('ul'); 
				if (getel === 1) { 
					thisitem.addClass('bounceOutRight animated');
					setTimeout(function() {
						thisitem.removeClass('bounceOutRight animated addtobasket'); 
						thisitem.appendTo('#purchased').last();
						getul.remove();
	        		}, 800); 
				} else {
					thisitem.addClass('bounceOutRight animated');
					setTimeout(function() {
			        	thisitem.removeClass('bounceOutRight animated addtobasket'); 
						thisitem.appendTo('#purchased').last();
			        }, 800); 
				}*/ 
			}
		});
  	}
  
  	function Json_add_to_basket(thisitem, itemid, getel) {
	  var sPageURL = window.location.search.substring(8).split('&');
	  $.ajax({
		  type: 'post',
		  ////href='".$saveurl."/shoppinglist/add_purchased.php?listid=".$list_id."&invenid=".$MIRow['iid']."'
		  url: saveurl + '/shoppinglist/add_purchased.php?listid=' + sPageURL[0] + '&invenid=' + itemid,
		  data: {
		    //getresult:val
		  },
		  success: function (response) {  
		      var getul = thisitem.closest('ul'); 
		      if (getel === 1) { 
			  	thisitem.addClass('bounceOutRight animated');
			  	setTimeout(function() {
	            	thisitem.removeClass('bounceOutRight animated addtobasket'); 
	            	thisitem.appendTo('#purchased').last();
	            	getul.remove();
	        	}, 800); 
			  } else {
				  thisitem.addClass('bounceOutRight animated');
				  	setTimeout(function() {
		            	thisitem.removeClass('bounceOutRight animated addtobasket'); 
						thisitem.appendTo('#purchased').last();
		        	}, 800); 
			  } 
		  }
	  });
 

  	}
  
  
  	function Json_add_as_favorit() { 
	  var favicon = $('#top').find('.add_as_favorites');
	  $.ajax({
	  type: 'post',
	  url: saveurl + '/recipe/add_as_favorit.php?' + sPageURL,
	  data: {
	    //getresult:val
	  },
	  success: function (response) { 
	     if (favicon.hasClass('fa-heart') === true) {
	        favicon.removeClass('fa-heart');
	        favicon.addClass('fa-heart-o');
	      } else {
	        favicon.removeClass('fa-heart-o');
	        favicon.addClass('fa-heart');
	      } 
	  }
	  });
	}
  	
  	function Json_loadmore_recipes_your() {
	  //var val = document.getElementById("result_no").value;
	  var val = $('#recipes.your').find('#result_no').val();
	  $.ajax({
	  type: 'post',
	  url: '/db_save/recipe/loadmore.php?testtestes',
	  data: {
	    getresult:val
	  },
	  success: function (response) {
	    //var content = document.getElementById("result_para");
	    //content.innerHTML = content.innerHTML+response; 
	    
/*
	    var newElement = document.createElement('#result_no');
		newElement.innerHTML = xmlhttp.responseText;
		document.getElementById("result_para").appendChild(newElement);
*/
	
	    // We increase the value by 2 because we limit the results by 2
	    var numb = document.getElementById("result_no").value = Number(val)+2;
	    numb; 
	  }
	  });
	}
  
  function GoogleAnalytics() {
	  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	  })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
	
	  ga('create', 'UA-49452106-1', 'auto');
	  ga('send', 'pageview');   
  }
  
  function Flipicon() {
	  var icon = $('#filterlist').find('.onoff i');
	  $(".onoff").click(function() {
	  	icon.toggleClass('fa-flip-horizontal');
	  });
  }
  
  function Filters() {
	var filters = $('.page-wrap').find('.filters');
	var filtersOverlay = filters.find('.filters--overlay');
	var arrow = filters.find('.arrow');
	var wrapper = filters.find('.wrapper');
	
	function filterContent() {
		wrapper.toggleClass('open');
		arrow.find('.fa').toggleClass('fa-angle-down');
		arrow.find('.fa').toggleClass('fa-angle-up');
		filtersOverlay.toggleClass('open');
	}
	
	
	$(arrow).on("click", function() {
		filterContent(); 
	});
	
	$(filtersOverlay).on("click", function() {
		filterContent();
	});
	  
	  
	  
  }
  
   
  function LoginSpinder() {
	  var spin = $('#signinform1').find('.fa-spin');
	  spin.hide();
	  $('.js-login').on("click", function() {
	  	spin.show();
	  });
	  
  }
  
  function SectionHeight() {
    var body = $('body');
    var setbody = body.height();
    var browse = $('#browse');
    var thisisdev = $('#thisisdev').height(); //16
    var topbar = $('#top').height() + 1; //82.992
    var settopbar = parseInt(topbar);
    var links = browse.find('.links').height(); //232
    var discover = browse.find('.discover').height(); //165
    var setsection = setbody - thisisdev - settopbar - 15;
    var setdiscoverheight = setsection - links;
    browse.find('.discover a').css('height', setdiscoverheight);
    //$('#browse').css('height',setsection);
    //console.log(sdf);
  }

  function BrowserLanguage() {
    var userLang = navigator.language || navigator.userLanguage;
    //console.log(userLang);
    //alert ("The language is: " + userLang);
  }

  function AddNewNameShoppingList() {
    //
    $("#popup").on("click", "#cta-newshoppinglist", function() {
      var $input = $('#input-newshoppinglist').val();
      //var $cta = $('#cta-newshoppinglist');
      alert($input);
      // var $js-hest = $('.js-hest');
      //alert('sdf');
      /*
				 var name = {
					 name: $js-hest.val(),
				 }
				  
				 
				 $.ajax({
					 type: 'POST',
					 url: '/db_save/shoppinglist/add_new_list.php',
					 data: name,
					 success: function(newShoppinglist) {
						 alert('OK!');
					 },
					 error: function() {
						 alert('fejl');
					 }
				 }); */
    });
  }
  /*
	        $("#popup").on("click", "#less", function() {
                   var num = +$("#envelopes").val() - 1;
                   if(num >= 1) {
                    $("#envelopes").val(num);
                   }
            });
	        
        */
  function getUrlParameter(sParam) {
    /*###################
            Titel:      Få URL parameter efter ønske
            Kommentar:  for at lave et output | var recipe = getUrlParameter('recipe');
            URL:        kan benyttes over hele app'en
            ###################*/
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] == sParam) {
        return sParameterName[1];
      }
    }
  }

  function WindowWidth() {
    /*###################
            Titel:      Tjek af width of the windows 
            Kommentar:  
            URL:        console.log som output.
            ###################*/
    if (subdomain === 'dev') {
      $(window).on('resize', function() {
        $windowWidth = $(this).width();
        console.log($windowWidth);
      });
    }
  }

  function OnOffSwitch() {
    /*###################
            Titel:   
            Kommentar:  On/Off Switch
            URL:        all over
            ###################*/
    $(".OnOffSwitch").click(function() {
      var getid = this.id;
      $(this).toggleClass('fa-rotate-180');
      var switchid = $('#' + getid + '_input');
      if ($(switchid).val().length == '') {
        $(switchid).val(1);
      } else {
        $(switchid).val('');
      } 
    });
  } //END KidFriendly;
  function Recipe_CompleteOneOfTheSteps() {
    /*###################
            Titel:   Recipe -> Complete One Of The Steps
            Kommentar:  
            URL:        /recipe/?id=[id]
            ###################*/
    $(".ConsiderIt").click(function() {
      var getid = $(this).parent().attr('id');
      $(this).toggleClass('Done');
    });
  }

  function EditItemFromShoppingList() { //Skal finde også navn skal ændres
    $(".show_form").click(function() {
      var service = this.id; // Example ubuntu-one
      var service_id = '#' + service + '-form'; // Example #ubuntu-one-form
      $(service_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
  }

  function SetLevel(Setid, SetLevel) {
    $("#" + Setid + ".ingredient_level_" + SetLevel + " .fa-angle-right").toggleClass(function() {
      if ($(this).parent().is("fa-angle-right")) {
        return "fa-angle-right";
      } else {
        return "fa-angle-down";
      }
    });
  }

  function LevelPriorStricture() {
    ///recipes/new_ingredient.php
    $(".level2, .level3, .level4, .level5  ").hide();
    
    $('.search').find('#js_mai_child').hide();
    $("#js_mai").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = getid + '_child'; // Example #ubuntu-one 
      
      $("#" + getid + " .fa-angle-right").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      $('#js_mai_child').slideToggle('fast', function() {});
    });

    $('.search').find('#js_cui_child').hide();
    $("#js_cui").click(function() {
	    var getid = this.id; // Example ubuntu-one
	    var view = getid + '_child'; // Example #ubuntu-one 
	    $("#" + getid + " .fa-angle-right").toggleClass(function() {
	      if ($(this).parent().is("fa-angle-right")) {
	        return "fa-angle-right";
	      } else {
	        return "fa-angle-down";
	      }
	    });
	    //console.log(view);
	    $('#js_cui_child').slideToggle('fast', function() {});
		 
    });
    
     $('.search').find('#js_dis_child').hide();
    $("#js_dis").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = getid + '_child'; // Example #ubuntu-one 
      $("#" + getid + " .fa-angle-right").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      //console.log(view);
      $('#js_dis_child').slideToggle('fast', function() {});
     
    });

    $('.search').find('#js_die_child').hide();
    $("#js_die").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = getid + '_child'; // Example #ubuntu-one 
      $("#" + getid + " .fa-angle-right").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      //console.log(view);
      $('#js_die_child').slideToggle('fast', function() {});
     
    });

     $('.search').find('#js_sea_child').hide();
    $("#js_sea").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = getid + '_child'; // Example #ubuntu-one 
      $("#" + getid + " .fa-angle-right").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      //console.log(view);
      $('#js_sea_child').slideToggle('fast', function() {});
     
    });
    
    $(".ingredient_level_1").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = '.level2_' + getid; // Example #ubuntu-one-form 
      
      $(view).slideToggle('fast', function() {});
      SetLevel(getid, 1); 
      
    });
    ///Her skal lige tilføjes nogle værider, så der 
    //er mulighed for at kunne tracke på id'erne.
    $(".ingredient_level_2").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = '.level3_' + getid; // Example #ubuntu-one-form 
      $(view).slideToggle('fast', function() {
        // Animation complete.
      });
      SetLevel(getid, 2);
    });
    $(".ingredient_level_3").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = '.level4_' + getid; // Example #ubuntu-one-form 
      $(view).slideToggle('fast', function() {
        // Animation complete.
      });
      SetLevel(getid, 3);
    });
    $(".ingredient_level_4").click(function() {
      var getid = this.id; // Example ubuntu-one
      var view = '.level5_' + getid; // Example #ubuntu-one-form 
      $(view).slideToggle('fast', function() {
        // Animation complete.
      });
      SetLevel(getid, 4);
    });
  }

  function MakeAsLink() {
    $("#make_as_link").on("click", function() {
      $("#make_as_link .fa-circle-o").toggleClass(function() {
        if ($(this).parent().is("fa-circle-o")) {
          return "fa-circle-o";
        } else {
          return "fa-circle";
        }
      });
      if ($('#make_as_link_name').val().length == '') {
        $('#make_as_link_name').val(1);
      } else {
        $('#make_as_link_name').val('');
      }
    });
    $("#basic_supplies").on("click", function() {
      $("#basic_supplies .fa-circle-o").toggleClass(function() {
        if ($(this).parent().is("fa-circle-o")) {
          return "fa-circle-o";
        } else {
          return "fa-circle";
        }
      });
      if ($('#basic_supplies_name').val().length == '1') {
        $('#basic_supplies_name').val('');
      } else {
        $('#basic_supplies_name').val('1');
      }
    });
    $("#MainIngredient").on("click", function() {
      $("#MainIngredient .fa-circle-o").toggleClass(function() {
        if ($(this).parent().is("fa-circle-o")) {
          return "fa-circle-o";
        } else {
          return "fa-circle";
        }
      });
      if ($('#MainIngredient_name').val().length == '1') {
        $('#MainIngredient_name').val('');
      } else {
        $('#MainIngredient_name').val('1');
      }
    });
  }

  function DynamicSelect() {
    /*###################
            Titel:   Dynamisk Dropdown 
            Kommentar:  Dynamisk Dropdown med location change
            URL:        Global
            ###################*/
    $('.dynamic_select').bind('change', function(event) {
      var url = $(this).val(); // get selected value
      if (url) { // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  }

  function EnvelopesToRecipe() {
    //
    /*###################
            Titel:   Antal kurverter for recipe
            Kommentar:  antale af varer ud fra kurverter
            URL:        /recipe/?id=[]
            ###################*/
    function amount() {
      var previousValue = parseFloat($("#previousServing").val());
      var newValue = parseFloat($("#envelopes").val());
      if (previousValue && newValue) {
        $('.ingredient').each(function(index, elem) {
          var ingredientNow = $('.amount', elem);
          var oldIngredientAmount = ingredientNow.text();
          var newIngredientAmount = oldIngredientAmount * newValue / previousValue;
          //alert(newIngredientAmount);
          ingredientNow.text(newIngredientAmount.toFixed(2));
        });
        $('#previousServing').val(newValue);
      }
    }
    //Recipe -> to shoppingbag (ingredients_you_need)
    $('.ingredients_you_need .checkboxstyle .fa-check-square').show();
    $('.ingredients_you_need').click(function() {
      var main = this.id;
      $("#" + main + " .checkboxstyle").toggleClass('remove_border');
      $("#" + main + " label i ").toggleClass('fa-remove');
      $("#" + main + " label i ").toggleClass('fa-plus-circle');
      $("#" + main + " .checkboxstyle .fa-check-square").toggle();
      //Finder user valg af ingredienter, og værdien sætte i hidden input
      if ($('#ingredient_' + main).val().length == 1) {
        $('#ingredient_' + main).val('');
      } else {
        $('#ingredient_' + main).val(1);
      }
    });
    //Recipe -> to shoppingbag (ingredients_may_have)
    $('.ingredients_may_have  .checkboxstyle .fa-check-square').hide();
    $('.ingredients_may_have').click(function() {
      var main = this.id;
      $("#" + main + " .checkboxstyle").toggleClass('remove_border');
      $("#" + main + " label i ").toggleClass('fa-remove');
      $("#" + main + " label i ").toggleClass('fa-plus-circle');
      $("#" + main + " .checkboxstyle .fa-check-square").toggle();
      //Finder user valg af ingredienter, og værdien sætte i hidden input
      if ($('#ingredient_' + main).val().length == 1) {
        $('#ingredient_' + main).val('');
      } else {
        $('#ingredient_' + main).val(1);
      }
    });
    //recipe ingredinets count
    $('.serving').bind('keyup', function(event) {
      amount();
    });
    // + / - 
    $("#more").on("click", function() {
      var num = +$("#envelopes").val() + 1;
      $("#envelopes").val(num);
      amount();
    });
    //ON the page
    $("#less").on("click", function() {
      var num = +$("#envelopes").val() - 1;
      if (num >= 1) {
        $("#envelopes").val(num);
      }
      amount();
    });
    //MEALPLANNER -> edit -> add +1
    $("#popup").on("click", "#more", function() {
      var num = +$("#envelopes").val() + 1;
      $("#envelopes").val(num);
    });
    //MEALPLANNER -> edit -> add +1
    $("#popup").on("click", "#less", function() {
      var num = +$("#envelopes").val() - 1;
      if (num >= 1) {
        $("#envelopes").val(num);
      }
    });
  }

  function AlertSuccess() {
    /*commen SETTINGS*/
    $('.alert.success').delay(3000).fadeOut(200);
  }

  function Stars() {
    //recipe -> add name -> stars in to the formfild.
    $('#star001').attr('disabled', true);
    $('#star002').attr('disabled', true);
    $('#star003').attr('disabled', true);
    $('#star004').attr('disabled', true);
    $('#star005').attr('disabled', true);
    $('#star006').attr('disabled', true);
    $('#star01').click(function() {
      $('#star001').attr('disabled', false);
    });
    $('#star02').click(function() {
      $('#star002').attr('disabled', false);
    });
    $('#star03').click(function() {
      $('#star003').attr('disabled', false);
    });
    $('#star04').click(function() {
      $('#star004').attr('disabled', false);
    });
    $('#star05').click(function() {
      $('#star005').attr('disabled', false);
    });
    $('#star06').click(function() {
      $('#star006').attr('disabled', false);
    });
    //recipe -> add_name -> stars
    $('#star01').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star-o');
      $("#star03").addClass('fa-star-o');
      $("#star04").addClass('fa-star-o');
      $("#star05").addClass('fa-star-o');
      $("#star06").addClass('fa-star-o');
    });
    $('#star02').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );  
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star');
      $("#star03").addClass('fa-star-o');
      $("#star04").addClass('fa-star-o');
      $("#star05").addClass('fa-star-o');
      $("#star06").addClass('fa-star-o');
    });
    $('#star03').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star');
      $("#star03").addClass('fa-star');
      $("#star04").addClass('fa-star-o');
      $("#star05").addClass('fa-star-o');
      $("#star06").addClass('fa-star-o');
    });
    $('#star04').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star');
      $("#star03").addClass('fa-star');
      $("#star04").addClass('fa-star');
      $("#star05").addClass('fa-star-o');
      $("#star06").addClass('fa-star-o');
    });
    $('#star05').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star');
      $("#star03").addClass('fa-star');
      $("#star04").addClass('fa-star');
      $("#star05").addClass('fa-star');
      $("#star06").addClass('fa-star-o');
    });
    $('#star06').click(function() { //star01
      //$( this ).css( "color", "#ccb700" );
      $("#star01").removeClass('fa-star-o');
      $("#star02").removeClass('fa-star-o');
      $("#star03").removeClass('fa-star-o');
      $("#star04").removeClass('fa-star-o');
      $("#star05").removeClass('fa-star-o');
      $("#star06").removeClass('fa-star-o');
      $("#star01").removeClass('fa-star');
      $("#star02").removeClass('fa-star');
      $("#star03").removeClass('fa-star');
      $("#star04").removeClass('fa-star');
      $("#star05").removeClass('fa-star');
      $("#star06").removeClass('fa-star');
      $("#star01").addClass('fa-star');
      $("#star02").addClass('fa-star');
      $("#star03").addClass('fa-star');
      $("#star04").addClass('fa-star');
      $("#star05").addClass('fa-star');
      $("#star06").addClass('fa-star');
    });
  }

  function OrientationChange() { // d. 27/03-16 dette udgår...
    //Landskabe display on phones
    $(window).on("orientationchange", function() {
      if (window.orientation == 0) {
        $("body").css({
          "display": "block"
        });
      } else {
        $("body").css({
          "display": "none"
        });
      }
    });
  }

  function NewUserItem_DropDown() {
    /*###########################
                /shopping_list/add.php?listid=[?]
            ############################*/
    $('#new_ingredient_group').hide();
    $("#new_ingredient_name").focus(function() {
      $('#new_ingredient_group').fadeIn(1000);
    });
  }

  function FormSubmitning() {
    //Submitning af form
    $('#signinform').click(function() {
      $('#signinform1').submit();
    });
    $('#signupform').click(function() {
      $('#signupform1').submit();
    });
    $('#createrecipe').click(function() {
      $('#createrecipe1').submit();
    });
  }
  
  function overlaywrapperhide() {
		var overlay = $('body').find('.overlaywrapper');
		overlay.hide();
  }
  
  function overlaywrapper() {
	  //$(".js-closeoverlay").on("click", function() {
		$("#popup").on("click", ".js-closeoverlay", function() {
		   var overlay = $('body').find('.overlaywrapper');
		   overlay.hide(); 
	  });
	 
  }


  function Overlay() {
    //set .overlay to element
    $(".overlay").on("click", function() {
      var page = $(this).attr('href');
      $("#popup").load(page);
      return false;
    });
  }

  function ShowHideStates() {
    /*#########
            Used under recipes
            ##########*/
    $(".lastlevel").hide();
    $(".subchild").hide();
    $(".product").hide();
    $(".lastlevel").click(function() {
      var setid = this.id;
      $("#" + setid + "> i").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      var ingre = this.id; // Example ubuntu-one
      var ingre_id = '.' + ingre; // Example #ubuntu-one-form
      //$(ingre_id).show();
      $(ingre_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $(".secondlevel").click(function() {
      var setid = this.id;
      $("#" + setid + "> i").toggleClass(function() {
        if ($(this).parent().is("fa-angle-right")) {
          return "fa-angle-right";
        } else {
          return "fa-angle-down";
        }
      });
      var ingre = this.id; // Example ubuntu-one
      var ingre_id = '.' + ingre; // Example #ubuntu-one-form
      //$(ingre_id).show();
      $(ingre_id).slideToggle('fast', function() {
        // $(".subchild").hide();
      });
    });
  }

  function RecipeSearchOverview() {
    $("#main-ingredient-secondlevel").hide();
    $("#cuisine-secondlevel").hide();
    $("#dish-type-secondlevel").hide();
    $("#dietary-consideration-secondlevel").hide();
    $("#season-or-occasion-secondlevel").hide();
    $("#main-ingredient").click(function() {
      var main = this.id; // Example ubuntu-one
      var main_id = '#' + main + '-secondlevel'; // Example #ubuntu-one-form
      //$(".lastlevel").toggle();
      $(main_id + " > .lastlevel").hide();
      $(main_id + " > li > i").removeClass("fa-angle-down");
      $("#main-ingredient > i").toggleClass(function() {
        if ($(this).parent().is(".fa-chevron-right")) {
          return "fa-chevron-right";
        } else {
          return "fa-chevron-down";
        }
      });
      $(main_id).slideToggle('fast', function() {
        // Animation complete. 
      });
    });
    $("#cuisine").click(function() {
      var cuisine = this.id; // Example ubuntu-one
      var cuisine_id = '#' + cuisine + '-secondlevel'; // Example #ubuntu-one-form
      $("#cuisine > i").toggleClass(function() {
        if ($(this).parent().is(".fa-chevron-right")) {
          return "fa-chevron-right";
        } else {
          return "fa-chevron-down";
        }
      });
      $("#cuisine-secondlevel > .lastlevel").toggle();
      $(cuisine_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $("#dish-type").click(function() {
      var dishtype = this.id; // Example ubuntu-one
      var dishtype_id = '#' + dishtype + '-secondlevel'; // Example #ubuntu-one-form
      $("#dish-type > i").toggleClass(function() {
        if ($(this).parent().is(".fa-chevron-right")) {
          return "fa-chevron-right";
        } else {
          return "fa-chevron-down";
        }
      });
      $("#dish-type-secondlevel > .lastlevel").toggle();
      $(dishtype_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $("#dietary-consideration").click(function() {
      var dietary = this.id; // Example ubuntu-one
      var dietary_id = '#' + dietary + '-secondlevel'; // Example #ubuntu-one-form
      $("#dietary-consideration > i").toggleClass(function() {
        if ($(this).parent().is(".fa-chevron-right")) {
          return "fa-chevron-right";
        } else {
          return "fa-chevron-down";
        }
      });
      $("#dietary-consideration-secondlevel > .lastlevel").toggle();
      $(dietary_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $("#season-or-occasion").click(function() {
      var season = this.id; // Example ubuntu-one
      var season_id = '#' + season + '-secondlevel'; // Example #ubuntu-one-form
      $("#season-or-occasion > i").toggleClass(function() {
        if ($(this).parent().is(".fa-chevron-right")) {
          return "fa-chevron-right";
        } else {
          return "fa-chevron-down";
        }
      });
      $("#season-or-occasion-secondlevel > .lastlevel").toggle();
      $(season_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
  }

  function FadeEffect() {
    $('a.fade').click(function(e) {
      e.preventDefault();
      //do other stuff when a click happens
    });
    $(".slidingDiv").hide();
  }

  function HideShowLevels() {
    //Category
    $(".HideCatDiv").hide();
    $(".ShowCatDiv").show();
    $(".HideChildDiv").hide();
    $(".ShowChildDiv").show();
    $(".HideProductDiv").hide();
    $(".ShowProductDiv").show();
    $(".HideChildDiv").click(function() { //Mangler!        
      var proid = this.id; // Example ubuntu-one d175_child    
      var pro_id = '.' + proid; // Example #ubuntu-one-form
      $(pro_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $(".ShowChildDiv").click(function() { //Mangler!        
      var child = this.id; // Example ubuntu-one d175_child    
      var cat_id = '.' + child + '_child'; // Example #ubuntu-one-form
      $(cat_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    $(".ShowCatDiv").click(function() {
      var cat = this.id; // Example ubuntu-one
      var cat_id = '#' + cat + '-form'; // Example #ubuntu-one-form
      $(this.i).toggleClass('fa-chevron-right', 'fa-chevron-down');
      $(".HideSubCatDiv").hide();
      $(cat_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
    //Sub Category
    $(".HideSubCatDiv").hide();
    $(".ShowSubCatDiv").show();
    $(".ShowSubCatDiv").click(function() {
      var subcat = this.id; // Example ubuntu-one
      var subcat_id = '#' + subcat + '-form'; // Example #ubuntu-one-form
      $(subcat_id).slideToggle('fast', function() {
        // Animation complete.
      });
    });
  }

  function AutoSize() {
    /*############
        KOmmentar: d. 19/06.15 -> er udkommeret grundet af den udskrif fejl.
        ############*/
    /*
        $(function(){
            $('.normal').autosize();
            $('.animated').autosize({append: "\n"});
        });
        */
  }

  function FileInput() {
    var wrapper = $('<div/>').css({
      height: 0,
      width: 0,
      'overflow': 'hidden'
    });
    var fileInput = $(':file').wrap(wrapper);
    //fileInput.change(function(){
    //    $this = $(this);
    //    $('#file').text($this.val());
    //})
    $('#file').click(function() {
      fileInput.click();
    }).show();
  }

  function NewIngredient() {
    $("#add_english").hide();
    $("#add_danish").hide();
    $("#add_german").hide();
    $(".new_ingredient .add_ingredient").on("click", function() {
      var ing = this.id;
      //alert(ing);
      $("#add_" + ing).slideToggle();
    });
  }
});
